"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import _ from "lodash";
let SelectElementDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.web_name = "";
    this.web_url = "";
    this.id = "";
    this.selectedIds = [];
    this.selectedLock = false;
    this.gridController = new GridController(new APIDataSource("api://base.auth/api/v1/web-resource-elements"));
  }
  open(item) {
    return __async(this, null, function* () {
      var _a;
      try {
        this.selectedLock = true;
        this.web_name = item.name;
        this.web_url = item.url;
        this.id = item.webElementResourceId;
        this.selectedIds = (_a = item.webElementResourceElements) != null ? _a : [];
        this.gridController.pagePosition = "dialog";
        this.gridController.query.filter = `webpageResourceId==${this.id}`;
        yield this.gridController.search();
        this.dialog.visible = true;
        this.selectedLock = false;
        this.$nextTick(function() {
          if (this.selectedIds.length > 0) {
            this.selectedLock = true;
            for (let data of this.selectedIds) {
              let item2 = _.find(this.gridController.result.datas, {
                id: data.id
              });
              console.log(item2);
              if (item2 !== void 0) {
                this._uiGrid._tableBody.toggleRowSelection(item2, true);
              }
            }
            this.selectedLock = false;
          }
        });
      } catch (error) {
      }
    });
  }
  selectItems(items) {
    try {
      if (!this.selectedLock) {
        let ids = _.map(items, "id");
        let selectIds = _.map(this.selectedIds, "id");
        let unSelectData = _.differenceWith(
          selectIds,
          ids,
          _.isEqual
        );
        for (let item of items) {
          let data = _.find(selectIds, (str) => str === item.id);
          if (data === void 0) {
            this.selectedIds.push({ id: item.id, name: item.name });
          }
        }
        for (const item of unSelectData) {
          const data = _.findIndex(this.selectedIds, (str) => str.id === item);
          let searchresult = _.find(this.gridController.result.datas, {
            id: item
          });
          if (searchresult !== void 0 && data !== -1) {
            this.selectedIds.splice(data, 1);
          }
        }
      }
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  //检测当前列表选中的数据
  checkSelectedGrid() {
    for (let data of this.selectedIds) {
      let selectedData = _.find(this.gridController.result.datas, {
        id: data.id
      });
      this.selectedLock = true;
      if (selectedData !== void 0) {
        this._uiGrid._tableBody.toggleRowSelection(selectedData, true);
      }
      this.selectedLock = false;
    }
  }
  confirm() {
    this.$emit("submitSelected", { selectedIds: this.selectedIds, webElementResourceId: this.id });
    this.cancel();
  }
  cancel() {
    this.selectedIds = [];
    this.dialog.visible = false;
  }
};
__decorateClass([
  Ref("uiGrid")
], SelectElementDialog.prototype, "_uiGrid", 2);
SelectElementDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid
    }
  })
], SelectElementDialog);
export {
  SelectElementDialog as default
};
